<template>
  <div class="myaccount">
    <div class="title">Welcome, <span>{{ firstName }}</span></div>
    <div class="account">
      <div class="account-top" style="margin-right:55px;">
        <img style="width:58px;height:58px;position:absolute;left: 50%;margin-left:-29px;top:0;margin-top:-29px;" src="../../assets/account/account01.png">
        <p class="f24 fweight" style="margin-top:40px;margin-bottom: 14px;">Your Profile</p>
        <p class="f24">Update your profile,edit login,email</p>
        <p style="margin-top: 29px;display:flex;justify-content: center;"><a @click="goAccountProfile" class="btn a1">View</a></p>
      </div>
      <div class="account-top">
        <img style="width:58px;height:58px;position:absolute;left: 50%;margin-left:-29px;top:0;margin-top:-29px;" src="../../assets/account/acount02.png">
        <p class="f24 fweight" style="margin-top:40px;margin-bottom: 14px;">Order History</p>
        <p class="f24">View past orders,quickly reorder</p>
        <p style="margin-top: 29px;display:flex;justify-content: center;"><a @click="goOrderList" class="btn a1">View</a></p>
      </div>
    </div>
    <div class="message">
      <a class="item a1" style="margin:0 20px;" @click="goAddress">
        <div class="f20">
          <img style="width:35px;height:25px;margin-right:8px;" src="../../assets/account/acount03.png">
          Payment and Shipping</div>
        <div class="f18">Manage your Addresses,Upload a Tax Certificate,Download Credit Application</div>
      </a>
      <a class="item a1" style="margin-right:20px;" @click="goSavedLists">
        <div class="f20">
          <img style="width:32px;height:31px;margin-right:8px;" src="../../assets/account/acount04.png">
          Your Saved Lists</div>
        <div class="f18">Create and update multiple saved lists.</div>
      </a>
      <a class="item a1" @click="goAccountProfile">
        <div class="f20">
          <img style="width:28px;height:31px;margin-right:8px;" src="../../assets/account/acount05.png">
          Login & Security</div>
        <div class="f18">Update your email, change yourpassword</div>
      </a>
      <a class="item a1" style="margin:0 20px;" @click="goOrderList">
        <div class="f20">
          <img style="width:36px;height:30px;margin-right:8px;" src="../../assets/account/acount06.png">
          Quickly Reorder</div>
        <div class="f18">View your order history and quickly reorder.</div>
      </a>
    </div>
    <div class="account-bottom">
      <p style="color: #000;font-size: 30px; font-weight:bold;margin-bottom:14px;">Need Additional Support?</p>
      <p style="color:#000;font-size:20px;">Find answers to frequently asked questions or contact us by photo or email.</p>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'Myaccount',
        components: {},
        data () {
            return {
              firstName:'',
            }
        },
        methods: {
          goAccountProfile() {
            this.$emit('changeTab', 'Account Profile');
          },
          goOrderList() {
            this.$emit('changeTab', 'Order History');
          },
          goSavedLists() {
            this.$emit('changeTab', 'Saved Lists');
          },
          goAddress() {
            this.$emit('changeTab', 'Address Book');
          },
        },
        mounted() {
          this.firstName = localStorage.getItem('firstName');
          console.log(this.firstName, 'this.firstName');
        },
    }
</script>

<style scoped>
.myaccount {
  width: 100%;
  height: auto;
  background: #fff !important;
  padding-top: 60px;
}
.title {
  font-size: 36px;
  font-weight:bold;
  color: #293c49;
  text-align:center;
  width: 100%;
  margin-bottom: 60px;
}
.account {
  display:flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 72px;
}
.account-top {
  border: 1px solid #f7f6f6;
  border-radius: 6px;
  width: 458px;
  height: 216px;
  text-align:center;
  box-shadow: 0 0 6px rgba(111, 107, 97, 0.19);
  position:relative;
}
.f24 {
  font-size: 24px;
  color:#000;
}
.fweight {
  font-weight: bold;
}
.btn {
  width: 83px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  background: #00718c;
  border-radius: 20px;
  text-align: center;
  font-size: 24px;
  text-align:center;
  line-height:40px;
  display:block;
}
.message {
  background:#f5f5f5;
  padding: 28px 0 33px 0;
  display:flex;
  justify-content: center;
  align-items: center;
}
.item {
  background: #fff;
  height: 160px;
  /* width: 335px; */
  border-radius: 6px;
  flex: 1;
}
.f20 {
  font-size: 20px;
  color:#000;
  font-weight: bold;
  padding-left:20px;
  margin-top: 35px;
  vertical-align: middle;
}
.f18 {
  font-size: 18px;
  color:#00718c;
  padding-left: 16px;
  margin-top:15px;
}
.account-bottom {
  margin:60px 0 175px 70px;
}
</style>